import { render } from "./claimExList.vue?vue&type=template&id=ed89c458&scoped=true"
import script from "./claimExList.vue?vue&type=script&lang=js"
export * from "./claimExList.vue?vue&type=script&lang=js"

import "./claimExList.vue?vue&type=style&index=0&id=ed89c458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed89c458"]])

export default __exports__